// extracted by mini-css-extract-plugin
export default {"containprod":"JM","containprod2":"KM","title":"LM","servings":"MM","recommendation":"NM","image":"OM","flavorswrap":"PM","flavorsgroupwrap":"QM","moredetailsWrap":"RM","infoWrap":"SM","price":"TM","regularPrice":"UM","netPrice":"VM","addtocartcontainer":"WM","error":"XM"};
    if(module.hot) {
      // 1715276859010
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  